function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import ProductDetailsData from '../ProductDetails.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
var PpcProductAvailability = function PpcProductAvailability() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    app = _useParams.app,
    productID = _useParams.productID;
  var rrLocations = useSelector(function (s) {
    return s.ppc.location.index || {};
  });
  var _useContext = useContext(ProductDetailsData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tableData = _useState2[0],
    setTableData = _useState2[1];
  var availableAt = state.availableAt,
    archived = state.archived;
  useEffect(function () {
    dispatch({
      type: ppcActions.location,
      payload: {}
    });
  }, []);
  var isAvailable = function isAvailable(categoryID) {
    return availableAt === null || availableAt === void 0 ? void 0 : availableAt.find(function (x) {
      return x._id === categoryID;
    });
  };
  useEffect(function () {
    if (!rrLocations) return;
    var data = [];
    Object.values(rrLocations).filter(function (x) {
      return !x.archived;
    }).filter(function (x) {
      return x.clientApp === app;
    }).forEach(function (x) {
      data.push({
        _id: x._id,
        name: x.name,
        available: isAvailable(x._id) ? true : false
      });
    });
    setTableData({
      columns: {
        id: {
          title: '_id',
          visible: false
        },
        name: 'Location',
        available: {
          title: 'Available',
          size: 'contain',
          onClick: function onClick(_ref) {
            var row = _ref.row;
            if (archived) return;
            dispatch({
              type: ppcActions.product,
              payload: {
                formData: {
                  productID: productID,
                  locationID: row._id
                },
                method: !row.available ? 'put' : 'delete',
                route: 'available-at'
              }
            });
          }
        }
      },
      data: data
    });
  }, [availableAt, rrLocations]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Availability"
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    filterColumns: ['title'],
    sort: {
      by: 'title'
    }
  }))));
};
export default PpcProductAvailability;